import React from "react";
import { ListBuilder, Table, ActionBar } from "@redriver/cinnamon";
import { Icon } from "semantic-ui-react";
import { TablePagination } from "components/pagination";
import {
  getReturnOnInvestments,
  editReturnOnInvestment,
  removeReturnOnInvestment,
} from "./actions";
import SearchReturnOnInvestments from "./SearchReturnOnInvestments";
import ReturnOnInvestmentActions from "./ReturnOnInvestmentActions";
import AddReturnOnInvestmentModal from "./AddReturnOnInvestmentModal";
import ReturnOnInvestmentLabel from "./ReturnOnInvestmentLabel";
import { SortHeader } from "features/../../../shared/components/tables/sortableTable";

const ListReturnOnInvestments = ({ dealerOfficeId, searchImage }) => (
  <React.Fragment>
    <h4>ROI</h4>
    <ListBuilder
      withTable
      initialPagination={{ pageSize: 25, pageNumber: 1 }}
      dataTransform={(data) => data.results}
      totalTransform={(data) => data.totalResults}
      loadAction={dealerOfficeId ? getReturnOnInvestments : null}
      loadParams={{ dealerOfficeId }}
      renderList={(tableProps, state, events) =>
        events && (
          <div className="content-container principal-list services-list roi-list">
            <ActionBar>
              <ActionBar.Item fluid>
                <SearchReturnOnInvestments
                  searchImage={searchImage}
                  value={state.filters}
                  onChange={events.onChangeFilters}
                />
              </ActionBar.Item>

              {dealerOfficeId && (
                <ActionBar.Item>
                  <ReturnOnInvestmentLabel
                    dealerOfficeId={dealerOfficeId}
                    onRefresh={events.onRefresh}
                  />
                </ActionBar.Item>
              )}

              <ActionBar.Space width={3}></ActionBar.Space>

              <ActionBar.Item align="right">
                {dealerOfficeId && (
                  <AddReturnOnInvestmentModal
                    dealerOfficeId={dealerOfficeId}
                    onSubmitted={events.onRefresh}
                  />
                )}
              </ActionBar.Item>
            </ActionBar>

            <Table
              {...tableProps}
              compact
              dataKey="id"
              emptyMessage="No ROI found"
              selectable
              className="return-on-investments-table"
            >
              <Table.Column
                field="name"
                title="Name"
                header={
                  <SortHeader
                    field="name"
                    title="Name"
                    value={state.filters}
                    onChange={events.onChangeFilters}
                  />
                }
                width="15%"
              />
              <Table.Column
                field="availableToSheet"
                title="Available to sheet"
                render={(x) => (x.availableToSheet ? Check : Cross)}
                align="center"
                width="10%"
              />
              <Table.Column
                field="defaultOnSheetView"
                title="Default on sheet view"
                render={(x) => (x.defaultOnSheetView ? Check : Cross)}
                align="center"
                width="10%"
              />
              <Table.Column
                field="defaultOnCustomerView"
                title="Default on Customer view"
                render={(x) => (x.defaultOnCustomerView ? Check : Cross)}
                align="center"
                width="10%"
              />
              <Table.Column
                field="meteredServicesText"
                title="Metered Services"
                width="55%"
              />
              <Table.Column
                hoverable
                align="right"
                render={(item) => (
                  <ReturnOnInvestmentActions
                    returnOnInvestment={item}
                    deleteAction={removeReturnOnInvestment}
                    editAction={editReturnOnInvestment}
                    onRefresh={events.onRefresh}
                    dealerOfficeId={dealerOfficeId}
                  />
                )}
              />
            </Table>

            <TablePagination
              pageNumber={state.pagination.pageNumber}
              onChange={events.onChangePagination}
              pageSize={state.pagination.pageSize}
              totalItems={state.total}
            />
          </div>
        )
      }
    />
  </React.Fragment>
);

const Check = <Icon name="check" />;
const Cross = <Icon name="close" />;

export default ListReturnOnInvestments;
